import { Button } from '@/components/ui/button';
import { ReactNode } from 'react';

type ErrorStateProps = {
  title?: ReactNode;
  message?: ReactNode;
  onRetry?: () => void;
  retryLabel?: string;
};

export function ErrorState({
  title = 'An error occurred',
  message = 'Please try again or contact support.',
  onRetry,
  retryLabel = 'Retry',
}: ErrorStateProps) {
  return (
    <div className="tw:container tw:flex tw:flex-col tw:gap-6 tw:py-8">
      <div className="tw:bg-destructive/10 tw:text-destructive tw:p-4 tw:rounded-lg">
        <h2 className="tw:text-xl tw:font-semibold">{title}</h2>
        <p className="tw:mt-2">{message}</p>
        {onRetry && (
          <Button className="tw:mt-4" onClick={onRetry}>
            {retryLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
